













































import { ApiClient } from "@/api/client";
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";

@Component
export default class PaymentResponse extends Vue {
  @Prop({ default: "" }) provider!: string;
  @Prop({ default: "" }) status!: string;
  @Prop({ default: "" }) paymentId!: string;

  api: ApiClient = new ApiClient();
  isLoading = false;
  confirmedByServer = false;

  content: any = {
    title: ""
  };

  get isSuccess(): boolean {
    return this.status === "success" && this.confirmedByServer;
  }

  async mounted() {
    if (this.status === "success") {
      this.isLoading = true;
      try {
        const response = await this.api.verifyPayment(
          this.provider,
          this.paymentId
        );
        this.confirmedByServer = response === "ok";

        const newAccount = await this.api.getAccountInfo();
        this.$store.commit("setUser", newAccount);
      } catch (e) {
        this.confirmedByServer = false;
      } finally {
        this.isLoading = false;
      }
    }

    if (this.isSuccess) {
      this.content.title = "Zahlung erfolgreich";
    } else {
      this.content.title = "Zahlung fehlgeschlagen";
    }
  }
}
